import React from 'react';

import { c } from 'ttag';

import {
    Sidebar as AppSidebar,
    AuthenticationStore,
    SidebarAccount,
    SidebarList,
    SidebarListItem,
    SidebarNav,
    useAuthentication,
    useCurrentUser,
} from '@freelancelabs/components';
import { ArrowLeft, LogoutOutline } from '@freelancelabs/icons';

import { useReturnTarget } from '../returnTarget';

/**
 * La barre latérale des écrans privés d'`account`, reprise de celle du portail.
 *
 * **UNE SEULE ENTRÉE, ET CE N'EST PAS UN CHOIX QU'ON OFFRE POUR RIEN.** La règle du dépôt
 * dit qu'un choix à une option se dit et ne s'offre pas ; une barre latérale n'est pas un
 * choix, c'est le repère qui dit où l'on est et qui l'on est. Sans elle, la page de profil
 * flottait seule sur du blanc, sans identité ni sortie, alors que les deux produits qui y
 * envoient portent la même barre.
 *
 * **AUCUN LIEN DE RETOUR VERS LE PRODUIT, et c'est une contrainte et non un oubli.** La
 * maquette du back-office en dessine un (« Retour au back-office ») ; il supposerait de
 * savoir d'où la personne vient, et `account` ne le sait pas :
 *
 * - les deux produits envoient vers `${PUBLIC_ACCOUNT_URL}/account`, un lien nu, sans
 *   paramètre d'origine ;
 * - `redirect-after-login` est **consommée** au premier départ, donc absente ensuite ;
 * - la liste des portées de `RedirectMiddleware` répond « cette personne a-t-elle le droit
 *   de se connecter », jamais « à quelle application », et son propre commentaire le dit.
 *
 * Un lien qui devinerait renverrait un administrateur interne sur le portail client une
 * fois sur deux. Le retour se fait donc par le bouton du navigateur, ce qui marche
 * puisqu'on est arrivé par un lien entre applications. Le jour où l'on veut ce lien, ce
 * sont les DEUX appelants qui doivent nommer leur origine.
 */
const Sidebar = () => {
    const { logout } = useAuthentication() as AuthenticationStore;
    const back = useReturnTarget();
    const { email, firstName, lastName } = useCurrentUser();

    const displayName = [firstName, lastName].filter(Boolean).join(' ') || email || '';

    return (
        <AppSidebar
            variant="portal"
            footer={
                <SidebarAccount name={displayName}>
                    <a
                        href="#logout"
                        className="sidebar-account__logout"
                        onClick={(event) => {
                            event.preventDefault();
                            void logout();
                        }}
                    >
                        <LogoutOutline />
                        {c('Account sidebar').t`Logout`}
                    </a>
                </SidebarAccount>
            }
        >
            <SidebarNav>
                <SidebarList>
                    {/* LE RETOUR, ET NON « MON PROFIL ». Une entrée qui mène à la page où l'on
                        est déjà est un contrôle qu'on actionne pour rien : il n'y a qu'un
                        écran privé ici, donc la seule navigation utile est celle qui SORT.

                        Elle est ici et plus au-dessus du titre : c'était le même geste à deux
                        endroits, et une porte suffit.

                        `SidebarListItem` rend un `Link` de react-router, qui sur une adresse
                        d'une AUTRE origine rend une ancre simple et fait une navigation
                        pleine page : c'est ce qu'on veut, et c'est vérifié à l'écran plutôt
                        que supposé.

                        « Réglages » et « Notifications » ne sont pas reprises du portail :
                        elles y sont désactivées avec « Bientôt », ce qui est honnête là où le
                        menu en compte sept ; ici elles seraient deux entrées mortes sur
                        trois. */}
                    <SidebarListItem title={back.label} icon={<ArrowLeft size={16} />} to={back.href} />
                </SidebarList>
            </SidebarNav>
        </AppSidebar>
    );
};

export default Sidebar;
